// The rules for the Provider Management search, kept free of React so they can be tested on their own.
// The server enforces the same rules (AdminProviderPaging); this only gives the admin an answer before
// the request is sent.

const MIN_TEXT = 2;
const clean = (s) => (typeof s === "string" ? s.trim() : "");

/** Why the search can't run yet, or null when it can. */
export function filterProblem(search, nephrologyOnly) {
  const first = clean(search && search.firstName);
  const last = clean(search && search.lastName);
  const npi = clean(search && search.npi);
  const specialty = clean(search && search.specialty);
  const state = clean(search && search.state);

  if (!first && !last && !npi && !specialty && !state && !nephrologyOnly) {
    return "Enter at least one filter: a name, NPI, specialty or state, or tick Nephrology only.";
  }
  if (first && first.length < MIN_TEXT) return "First name needs at least 2 characters.";
  if (last && last.length < MIN_TEXT) return "Last name needs at least 2 characters.";
  if (specialty && specialty.length < MIN_TEXT) return "Specialty needs at least 2 characters.";
  if (state && !/^[A-Za-z]{2}$/.test(state)) return "State must be a 2-letter code, for example IL.";
  if (npi && !/^\d{1,10}$/.test(npi)) return "NPI must be digits only (up to 10).";
  return null;
}

export const hasEnoughFilter = (search, nephrologyOnly) => filterProblem(search, nephrologyOnly) === null;

// The server will not page beyond this many pages (page numbers start at 0), so the pager must not offer more.
export const MAX_PAGE_INDEX = 2000;
